import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './i18n'; // Initialize i18next
import LanguageRedirector from './components/LanguageRedirector';
import AppLayout from './components/AppLayout';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import Projects from './pages/Projects/Projects';
import Contact from './pages/Contact/Contact';
import PrivacyPolicy from './pages/Legals/PrivacyPolicy';
import DataTreatment from './pages/Legals/DataTreatment';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Root language redirector */}
          <Route path="/" element={<LanguageRedirector />} />
          
          {/* Main App Layout mapped to a URL parameter defining the language */}
          <Route path="/:lang" element={<AppLayout />}>
            
            {/* SPANISH ROUTES (when lang === 'es') */}
            <Route index element={<Home />} />
            <Route path="nosotros" element={<About />} />
            <Route path="servicios" element={<Services />} />
            <Route path="proyectos" element={<Projects />} />
            <Route path="contacto" element={<Contact />} />
            <Route path="politica-privacidad" element={<PrivacyPolicy />} />
            <Route path="tratamiento-datos" element={<DataTreatment />} />

            {/* ENGLISH ROUTES (when lang === 'en') */}
            {/* Index is shared, so we don't repeat index element. If /en is hit, it points to Home */}
            <Route path="about" element={<About />} />
            <Route path="services" element={<Services />} />
            <Route path="projects" element={<Projects />} />
            <Route path="contact" element={<Contact />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="data-management" element={<DataTreatment />} />

          </Route>

          {/* Fallback Catch-all -> Redirects back to Root Language Redirector */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
